import SelfiePreviewTile from '@/components/teleop/SelfiePreviewTile';
import { Button } from '@/components/ui/button';

type TeleopBottomDockProps = {
  isMobileLandscapeMode: boolean;
  selfieStream: MediaStream | null;
  selfieEnabled: boolean;
  selfiePreviewVisible: boolean;
  selfieSupported: boolean;
  selfieNotice: string | null;
  canShowDesktopSelfieHideControl: boolean;
  onDisableSelfie: () => void;
  onToggleSelfie: () => void | Promise<void>;
  onHideSelfie: () => void;
  onShowSelfie: () => void;
  controlsEnabled: boolean;
  onTriggerGrab: () => void;
};

const TeleopBottomDock: React.FC<TeleopBottomDockProps> = ({
  isMobileLandscapeMode,
  selfieStream,
  selfieEnabled,
  selfiePreviewVisible,
  selfieSupported,
  selfieNotice,
  canShowDesktopSelfieHideControl,
  onDisableSelfie,
  onToggleSelfie,
  onHideSelfie,
  onShowSelfie,
  controlsEnabled,
  onTriggerGrab,
}) => {
  const showSelfieEnableButton = !selfieEnabled;
  const showSelfieRestoreButton =
    selfieEnabled &&
    !selfiePreviewVisible &&
    canShowDesktopSelfieHideControl;

  return (
    <div className="absolute left-1/2 bottom-[calc(env(safe-area-inset-bottom,0px)+28px)] z-20 flex -translate-x-1/2 flex-col items-center gap-3 max-[600px]:gap-2">
      {!isMobileLandscapeMode ? (
        <>
          <SelfiePreviewTile
            stream={selfieStream}
            visible={selfieEnabled && selfiePreviewVisible}
            onClick={onDisableSelfie}
            onHide={canShowDesktopSelfieHideControl ? onHideSelfie : undefined}
          />
          {showSelfieEnableButton ? (
            <div className="pointer-events-auto flex flex-col items-center gap-2">
              <Button
                type="button"
                variant="ghost"
                className="h-[clamp(96px,18vw,140px)] w-[clamp(96px,18vw,140px)] rounded-2xl border border-white/15 bg-black/40 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/70 shadow-[0_18px_30px_rgba(0,0,0,0.35)] backdrop-blur-xl hover:bg-black/50"
                onClick={() => {
                  void onToggleSelfie();
                }}
                disabled={!selfieSupported}
              >
                <span className="flex flex-col items-center leading-[1.05]">
                  <span>ENABLE</span>
                  <span>SELFIE CAM</span>
                </span>
              </Button>
              {selfieNotice ? (
                <div className="text-[10px] uppercase tracking-[0.2em] text-white/70">
                  {selfieNotice}
                </div>
              ) : null}
            </div>
          ) : null}
          {showSelfieRestoreButton ? (
            <div className="pointer-events-auto">
              <Button
                type="button"
                variant="ghost"
                className="h-9 rounded-full border border-white/15 bg-black/40 px-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-white/70 shadow-[0_14px_24px_rgba(0,0,0,0.35)] backdrop-blur-xl hover:bg-black/50"
                onClick={onShowSelfie}
              >
                Show selfie
              </Button>
            </div>
          ) : null}
        </>
      ) : null}
      <div className="pointer-events-auto">
        <Button
          type="button"
          variant="secondary"
          className="h-12 rounded-full border border-white/15 bg-white/10 px-10 text-xs font-semibold uppercase tracking-[0.3em] text-white hover:bg-white/20 disabled:opacity-100"
          onPointerDown={(event) => {
            event.preventDefault();
            onTriggerGrab();
          }}
          onKeyDown={(event) => {
            const isActivationKey =
              event.key === ' ' ||
              event.key === 'Enter';

            if (!isActivationKey) {
              return;
            }

            event.preventDefault();
            onTriggerGrab();
          }}
          disabled={!controlsEnabled}
        >
          Grab
        </Button>
      </div>
    </div>
  );
};

export default TeleopBottomDock;
